import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
import { i18n } from '@/boot/i18n';
import { FIB } from '@/config/constants';
var STAFF_RENDER_TYPE = FIB.STAFF_RENDER_TYPE,
    STAFF_FOLLOWUP_TYPE = FIB.STAFF_FOLLOWUP_TYPE;
export default {
  name: 'FibStaffQuestion',
  props: {
    renderType: {
      type: Number,
      default: 0,
      required: true
    },
    followupType: {
      type: Number,
      default: STAFF_FOLLOWUP_TYPE.TAGS
    },
    staff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      description: ''
    };
  },
  computed: {
    component: function component() {
      var _STAFF_RENDER_TYPE$TE;

      return (_STAFF_RENDER_TYPE$TE = {}, _defineProperty(_STAFF_RENDER_TYPE$TE, STAFF_RENDER_TYPE.TEXT, {
        type: 'fib-comments',
        props: {
          label: i18n.t('questions.comments.enter'),
          rows: 4,
          // Give textarea a minimum height of 4 rows
          value: this.description
        }
      }), _defineProperty(_STAFF_RENDER_TYPE$TE, STAFF_RENDER_TYPE.SELECT, {
        type: 'fib-staff-selection',
        props: {
          staff: this.staff,
          tags: this.tags,
          filtersList: [{
            title: 'All',
            value: 'all'
          }],
          followupType: this.followupType
        }
      }), _STAFF_RENDER_TYPE$TE)[this.renderType];
    }
  },
  methods: {
    /**
     * Handle input events
     */
    onInput: function onInput(value) {
      // Update any local state - As FIBComments doesn't have any, we do it on its behalf
      if (this.renderType === STAFF_RENDER_TYPE.TEXT) {
        this.description = value;
      } // Forward all emits on (as FIBQuizScreen expects).


      this.$emit('input', {
        // Attach the render type used so we can contextualise what value is.
        renderType: this.renderType,
        value: value
      });
    }
  }
};